import { SalesInvoiceReviewDetailPage } from "@/features/sales-invoice-review/pages/SalesInvoiceReviewDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-invoice-review/$id/detail")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["sales_invoice_review.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesInvoiceReviewDetailPage,
});
